export default __webpack_public_path__ + "static/2022-db0a274d27e570aea90117e32ae7a65e.png";